import {LitElement} from 'lit';
import {customElement} from 'lit/decorators.js';
import "@/components/form/form.scss"
import {query} from "lit/decorators/query.js";
import {SbkButton} from "@/components/button/button";
import {SbkBanner} from "@/components/banner/banner";
import "@/components/ovulation-calculator/ovulation-calculator.scss"
import {SbkForm} from "@/components/form/form.ts";

@customElement('sbk-ovulation-calculator')
export class SbkOvulationCalculator extends LitElement {

    @query('form')
    _form!: HTMLFormElement

    @query('sbk-banner')
    _container!: SbkBanner

    @query('sbk-button')
    _submitButton!: SbkButton


    connectedCallback() {
        super.connectedCallback();
        this._form.addEventListener('submit', (e) => {
            e.preventDefault()
            this._onSubmit();
        });
    }

    protected createRenderRoot() {
        return this
    }

    private _onSubmit() {
        const invalidElements = SbkForm.validate(this._form);
        if (invalidElements.length) {
            const firstInvalidElement = invalidElements[0];
            firstInvalidElement.focus({preventScroll: true});
            firstInvalidElement.scrollIntoView({behavior: 'smooth'});
        } else {
            fetch(this._form.action, {
                method: this._form.method,
                body: new FormData(this._form),
            })
                .then((response) => {
                    return response.text()
                })
                .then((data) => {
                    this._container.innerHTML = data;
                    this._container.scrollIntoView({
                        behavior: 'smooth'
                    })
                    this._form.addEventListener('submit', (e) => {
                        e.preventDefault()
                        this._onSubmit();
                    });
                })
        }
    }
}
